/*
 * LICENSE PROTECTED SOFTWARE
 * (c) 2026  @cemdemirci0101
 * (c) 2026 All Rights Reserved.
 */

import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useParams } from "react-router-dom";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { Toaster } from "./components/ui/sonner";
import DashboardLayout from "./layouts/DashboardLayout";
import { publicRoutes, dashboardRoutes } from "./routes";
import CookieBanner from "./components/CookieBanner";

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <div className="w-8 h-8 border-4 border-blue-600 border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }
  if (!user) return <Navigate to="/giris" replace />;
  return children;
};

const DashboardWrapper = ({ children }) => (
  <ProtectedRoute>
    <DashboardLayout>{children}</DashboardLayout>
  </ProtectedRoute>
);

const ParamWrapper = ({ Component }) => {
  const params = useParams();
  return <Component {...params} />;
};

function App() {
  return (
    <AuthProvider>
      <div className="App">
        <BrowserRouter>
          <Routes>
            {publicRoutes.map(r => (
              <Route key={r.path} path={r.path} element={<r.element />} />
            ))}
            {dashboardRoutes.map(r => (
              <Route
                key={r.path}
                path={r.path}
                element={
                  <DashboardWrapper>
                    {r.useParams ? <ParamWrapper Component={r.element} /> : <r.element />}
                  </DashboardWrapper>
                }
              />
            ))}
            <Route path="*" element={<Navigate to="/panel" replace />} />
          </Routes>
          <CookieBanner />
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </div>
    </AuthProvider>
  );
}

export default App;
